import {lazy} from 'react';

export const LazyDetailsSection = lazy(() =>
	import('components').then(m => ({default: m.DetailsSection})),
);

export const LazyPdfViewer = lazy(() =>
	import('components').then(m => ({default: m.PdfViewer})),
);

export const LazyParagraphsComparisonPanel = lazy(() =>
	import('../ParagraphsComparisonPanel').then(m => ({default: m.default})),
);

export const LazyParagraphGridView = lazy(() =>
	import('../components/GridView/ParagraphGridView').then(m => ({
		default: m.ParagraphGridView,
	})),
);

export const LazyWorkflowDialog = lazy(() =>
	import('../components/DocumentDetails/WorkflowDialog/WorkflowDialog').then(
		m => ({default: m.WorkflowDialog}),
	),
);

export const LazyViewParagraphsForm = lazy(() =>
	import(
		'../components/DocumentDetails/ViewParagraphsForm/ViewParagraphsForm'
	).then(m => ({default: m.ViewParagraphsForm})),
);

export const LazyEditParagraphsForm = lazy(() =>
	import(
		'../components/DocumentDetails/EditParagraphsForm/EditParagraphsForm'
	).then(m => ({default: m.EditParagraphsForm})),
);

export const LazyAssignRequirementsForm = lazy(() =>
	import('../components/DocumentDetails/AssignRequirementsForm').then(m => ({
		default: m.AssignRequirementsForm,
	})),
);

export const LazyRemoveRequirementsForm = lazy(() =>
	import('../components/DocumentDetails/RemoveRequirementsForm').then(m => ({
		default: m.RemoveRequirementsForm,
	})),
);

export const LazyCommentForm = lazy(() =>
	import('components/CommentForm').then(m => ({default: m.CommentForm})),
);

export const LazyFAQForm = lazy(() =>
	import('components/FAQForm').then(m => ({default: m.FAQForm})),
);

export const LazyKeywordAssignmentForm = lazy(() =>
	import('../components/DocumentDetails/KeywordAssignmentForm').then(m => ({
		default: m.KeywordAssignmentForm,
	})),
);

export const LazyCompareversionForm = lazy(() =>
	import('../components/DocumentDetails/CompareVersionForm').then(m => ({
		default: m.CompareversionForm,
	})),
);

export const LazyCompareVersionPanel = lazy(() =>
	import(
		'../components/DocumentCompare/CompareVersionPanel/CompareVersionPanel'
	).then(m => ({default: m.CompareVersionPanel})),
);

export const LazyRegulatoryDocumentsForm = lazy(() =>
	import('../components/RegulatoryDocumentsForm/RegulatoryDocumentsForm').then(
		m => ({
			default: m.RegulatoryDocumentsForm,
		}),
	),
);

export const LazyParagraphTableOfContents = lazy(() =>
	import(
		'../components/DocumentDetails/ParagraphTableOfContents/ParagraphTableOfContents'
	).then(m => ({default: m.ParagraphTableOfContents})),
);

export const LazyRegulatoryDocumentJSONForm = lazy(() =>
	import('../components/RegulatoryDocumentJSONForm').then(m => ({
		default: m.RegulatoryDocumentJSONForm,
	})),
);

export const LazyParagraphsList = lazy(() =>
	import('./RegDocDetailsPage.ParagraphsList').then(m => ({
		default: m.RegDocDetailsPageParagraphsList,
	})),
);
